import { Component, ChangeDetectorRef, ElementRef, ViewChild, Input, Output, EventEmitter, HostListener, ViewContainerRef } from '@angular/core';
import { Events, ViewController, NavParams, ToastController, AlertController, } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ModalController } from 'ionic-angular';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { Http } from '@angular/http'
import 'rxjs/add/operator/map';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DomSanitizer } from '@angular/platform-browser';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service'
@Component({
  selector: 'page-template-lists',
  templateUrl: 'template-lists.html',
})
export class TemplateListsPage {
  @Input() selectTemplates: any = [];
  @Input() templateType: any;
  @Output() clear_properties = new EventEmitter<any>();
  objSelectTemplate: any;
  arrTemplates: any = [];
  selectTemp: any = [];
  arrTemplateCategory: any = [];
  objCurrentTemplate: any = "";
  TemplateSelection: any;
  showTemplates: boolean = false;
  selectedTemplateIdx: any;
  templateName: any;
  expandHeightValue: number = 34;
  hideMyTemplates: boolean = true;
  tmAppUrl: string = '';
  urlSafe: any;
  TempName: any;
  @Input() set templateSelection(v: any) {
    this.TemplateSelection = v;
  };
  objCurrentSelectedTemplate: any = [];
  multipleTemplateSelectedList: any = [];
  multipleTemplateSelected: any = [];
  selectionTemplate: any = '';
  public items: any = [];
  selectCategory: any = '';
  selectedCategoryList: any = [];
  searchTemplate: string = '';
  accorianExpand: boolean = true;
  footerSave: any = false;
  currentDeleteTemplate: any = [];
  deleteExpandStatus = false;
  objCurrentSelectedTemplateList: any = [];
  passingParams: any = {};
  sideWidth: string;
  broadcastSubs: any;
  @Output() showTemplateStatus = new EventEmitter();
  @ViewChild('lightbox-target', { read: ViewContainerRef, static: false }) lightBox: ElementRef;

  constructor(public communicationServ: CommunicationServiceProvider, public toastController: ToastController, private EncrDecrService: EncrDecrServiceProvider, private cdr: ChangeDetectorRef, private changeDetection: ChangeDetectorRef, public navParams: NavParams, public driveServiceProvider: DriveServiceProvider, public sanitizer: DomSanitizer, public configApiService: ConfigApiServiceProvider, public events: Events, public http: Http, public modalCtrl: ModalController, public viewCtrl: ViewController, public configureService: ConfigureServiceProvider, public alertctrl: AlertController,) {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "main") {
          if (data.event === 'showTemplates') {
            let status = data['status'];
            if (status) {
              this.showTemplates = false;
              this.hideMyTemplates = true;
              this.searchTemplate = '';
              this.selectCategory = '';
              let __self = this;
              this.arrTemplates = [];
              this.getAllTemplates(__self);
            } else {
              this.showTemplates = false;
              this.hideMyTemplates = true;
              this.searchTemplate = '';
              this.selectCategory = '';
            }
          }
        }
      });
  }

  ngOnInit() {
    this.driveServiceProvider.getSideBar.subscribe((res: string) => {
      this.sideWidth = res;
    })
    if (this.driveServiceProvider.activeSideMenu != 'Templates') {
      let __self = this;
      this.getAllTemplates(__self);
    }
    if (this.templateType) {
      this.selectionTemplate = this.templateType;
    }
    this.objCurrentSelectedTemplate = this.selectTemplates;
    if (this.selectionTemplate == "Multiple") {
      this.multipleTemplateSelected = this.objCurrentSelectedTemplate["template"];
      this.TempName = this.driveServiceProvider.storeWrap.storeTemplates;
      this.multipleTemplateSelected.forEach(multiTemp => {
        if(this.TempName[multiTemp.id] != undefined){
          this.multipleTemplateSelectedList.push(this.TempName[multiTemp.id]);
        }
      })
    }

  }

  expandItem(item, e): void {
    if (this.selectedCategoryList.indexOf(item.category) > -1) {
      this.selectCategory = item.category;
      let selectedCategoryIdx = this.selectedCategoryList.indexOf(item.category);
      this.selectedCategoryList.splice(selectedCategoryIdx, 1);
    }
    if (this.selectCategory == '') {
      this.selectCategory = item.category;
    } else {
      if (this.selectCategory == item.category) {
        this.selectCategory = '';
      } else {
        this.selectCategory = item.category;
      }
    }
  }

  expandHeight(height) {
    return this.expandHeightValue * height;
  }

  styleObject(template) {
    if (template.templateName === 'Blank') {
      return { display: 'none' }
    }
    if (template.id === undefined) {
      return { display: 'none' }
    }
  }

  dragMoved(e, action, i) {
    console.log("move", e, action, i);
    if (i == 0) {
      return;
    }
  }

  dragStart(e, action, i) {
    if (i == 0) {
      return;
    }
    console.log("start", e, action);
  }

  dragEnded(e, action) {
    console.log("end", e, action);
  }

  drop(event: CdkDragDrop<string[]>) {
    console.log("sort", this.multipleTemplateSelectedList);
    if (event.previousIndex > 0 && event.currentIndex > 0) {
      moveItemInArray(this.multipleTemplateSelectedList, event.previousIndex, event.currentIndex);
      console.log("end  ", this.multipleTemplateSelectedList, event.previousIndex, event.currentIndex);

      this.selectedTemplateSort(this.multipleTemplateSelectedList);
    }
  }

  selectedTemplateSort(e) {
    var postData = {};
    var postArr = [];
    this.multipleTemplateSelectedList.forEach(element => {
      postData = { id: element.id, filterParams: element.filterParams };
      postArr.push(postData);
    });
    this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'updateFolderProperties', status: true, selectedTemplates: postArr });
  }

  ngAfterViewInit() {
    if (this.driveServiceProvider.activeSideMenu == 'Templates') {
      this.openTMAppManager();
      this.cdr.detectChanges();
    }
  }

  openTMAppManager() {
    this.showTemplates = true;
    // this.configApiService.templateMangerUrl = 'http://localhost:8101/?server=local&host=https://prodcast.cloud:3780'//dev
    // this.configApiService.templateMangerUrl = 'http://localhost:8101/?server=drive1'//live/
    let urlParams = '&appCode=' + this.configApiService.currentDriveApp['app_code'] + '&studio=' + this.configureService.getStudio() + '&userid=' + this.configureService.getLoginUserID();
    let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);
    this.tmAppUrl = this.configApiService.templateMangerUrl + '&templateParams=' + encUrlParams;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.tmAppUrl);
  }


  getAllTemplates(data) {
    if (this.driveServiceProvider.storeWrap.storeTemplates.length != 0) {
      let templateData = this.driveServiceProvider.storeWrap.storeTemplates;
      this.setAllTemplates(templateData);
    } else {
      this.driveServiceProvider.storeWrap.storeTemplates = {};
      let __self = data;
      this.driveServiceProvider.getTemplates((templateData) => {
        this.setAllTemplates(templateData);
      });
    }
  }

  setAllTemplates(templateData) {
    let __self = this;
    Object.keys(templateData).forEach(element => {
      this.arrTemplates.push(templateData[element]);
    });
    this.arrTemplateCategory = [];
    Object.keys(this.arrTemplates).forEach(templateID => {
      let element = this.arrTemplates[templateID];
      if (!element['category']) {
        element['category'] = 'Default';
      }

      let templateCat = __self.arrTemplateCategory.find(function (template) {
        return template.category === element['category'];
      });
      if (templateCat === undefined) {
        templateCat = { 'category': element['category'], templates: [] };
        __self.arrTemplateCategory.push(templateCat);
      }
      templateCat['templates'].push(element);
    });
    this.activeTemplate(__self.arrTemplateCategory);
  }

  activeTemplate(data) {
    var parentIdx;
    var childIdx;
    let selcat = [];
    if (this.selectionTemplate == "Multiple") {
      if (this.objCurrentSelectedTemplate["template"][0] != null && this.objCurrentSelectedTemplate["template"][0]["templateName"] != "") {
        this.multipleTemplateSelectedList = this.objCurrentSelectedTemplate["template"];
      }
      setTimeout(() => {
        var objTemplate = [];
        this.objCurrentSelectedTemplate["template"].forEach((element, idx) => {

          element = this.driveServiceProvider.storeWrap.storeTemplates[element["id"]];
          if (element != undefined) {
            objTemplate.push(element)
          }
          if (element) {
            selcat = element["category"];
            if (this.selectedCategoryList.length == 0) {
              this.selectedCategoryList.push(selcat);
            } else {
              let idx = this.selectedCategoryList.findIndex(data => data === element["category"]);
              if (idx < 0) {
                this.selectedCategoryList.push(selcat);
              }
            }
            parentIdx = data.findIndex(data => data.category === element["category"]);
            if (parentIdx != -1) {
              childIdx = data[parentIdx]['templates'].findIndex(data => data.id === element["id"]);
            }
          }

        });
        console.log("searchTemplate", this.searchTemplate);
        if (this.searchTemplate == "") {
          this.multipleTemplateSelectedList = []
          this.multipleTemplateSelectedList = objTemplate;
          console.log("multipleTemplateSelectedList", this.multipleTemplateSelectedList)
        } else {
          this.multipleTemplateSelectedList = objTemplate;
        }

      }, 300)
    }
  }


  selectTemplate(e, clickedTemplate, i, templateType) {
    this.footerSave = true;
    if (templateType == 'Multiple') {
      this.templateName = clickedTemplate.templateName;
      this.selectedTemplateIdx = i;
      let idx = this.multipleTemplateSelectedList.findIndex(e => e.id == clickedTemplate.id);
      if (idx < 0) {
        this.multipleTemplateSelectedList.push(clickedTemplate);
      } else {
        const toast = this.toastController.create({
          message: 'Already selected this Template',
          duration: this.configApiService.toastDuration
        });
        toast.present();

      }

    } else {
      if (this.TemplateSelection == 'New') {
        this.driveServiceProvider.assignTemplateToFolder([{ 'id': clickedTemplate.id, 'filterParams': {} }], this.driveServiceProvider.objCreatedFolder, this.getAssignedTemplate);
      } else {
        this.showTemplates = true;
        this.hideMyTemplates = false;
        this.objCurrentTemplate = clickedTemplate;
      }
    }
    console.log(" this.objCurrentSelectedTemplate", this.multipleTemplateSelectedList);
  }

  removeTemplate(e, clickedTemplate) {
    this.footerSave = true;
    this.templateName = clickedTemplate.templateName;
    var index = this.multipleTemplateSelectedList.findIndex(p => p.id == clickedTemplate.id);
    this.multipleTemplateSelectedList.splice(index, 1);
  }

  getAssignedTemplate = ((template) => {
    this.objSelectTemplate = template;
    if (this.objSelectTemplate.template.length > 0) {
      this.showTemplates = false;
      this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: this.showTemplates });
    }
  })

  pushTemplate() {
    this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'updateFolderProperties', status: true, selectedTemplates: this.multipleTemplateSelectedList });
    this.footerSave = false;
    this.clear_properties.emit();
  }

  closeLightBox(e) {
    console.log("close");
  }

  openLightbox(e) {
    console.log("open");
  }

  searchInput() {
    if (this.searchTemplate != "") {
      return this.searchTemplate;
    }
  }

  createTemplate() {
    this.showTemplates = true;
    this.objCurrentTemplate = "";
  }

  closeTemplateManager(e) {
    this.showTemplates = false;
  }

  discardSearch(e) {
    this.searchTemplate = '';
  }

  closeTemplateListPage() {
    this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: false });
  }


  deleteTemplate(e, selTemp) {
    this.deleteExpandStatus = true;
    let alert = this.alertctrl.create({
      title: 'Are you sure, want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            this.currentDeleteTemplate = selTemp;
            let pushDeleteData = {
              "ScreenName": selTemp.id,
              "Action": "delete",
              "userid": this.configureService.getLoginUserID(),
            }
            var objData = Object.assign({}, this.configApiService.driveApi.deleteTemplate.params, pushDeleteData, { "client": this.configureService.getStudio() })
            this.configApiService.pushRequest(objData, this.submitSuccess);
          }
        }
      ]
    });
    alert.present();
  }

  submitSuccess = ((resData) => {
    this.selectCategory = this.currentDeleteTemplate.category
    console.log("delete res", resData);
    if (resData == 'SUCCESS') {
      var index;
      let dltIdx = this.arrTemplateCategory.findIndex(e => e.category == this.currentDeleteTemplate.category);
      if (dltIdx != -1) {
        index = this.arrTemplateCategory[dltIdx].templates.findIndex(e => e.id == this.currentDeleteTemplate.id);
        console.log("delete Temp", this.arrTemplateCategory);

      }
      if (index != -1) {
        document.getElementById('cardTemplateList_' + this.arrTemplateCategory[dltIdx].templates[index].id).parentElement.style.display = "none";
        this.arrTemplateCategory[dltIdx].templates.splice(index, 1);
        this.driveServiceProvider.deleteTemplate(this.currentDeleteTemplate.id);
        console.log("delete Temp", this.arrTemplateCategory);
        const toast = this.toastController.create({
          message: 'Template Deleted successfully !!',
          duration: this.configApiService.toastDuration,
        });

      }
    }
  })

  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./src/pages/template-lists/template-lists.ts